<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <tabs
      v-else-if="!this.loading && !this.errormessage"
      class="d-none d-md-block"
      pills
      type="primary"
      icons
      centered
      value="position"
    >
      <tab-pane
        id="position"
        key="position"
      >
        <span slot="title">
          <div class="row align-items-center">
            <div class="content-heading">Staff Positions</div>
          </div>
        </span>
        <card class="mt-3">
          <el-table
            :data="rowData"
            header-row-class-name="text-danger"
            :row-class-name="leadershipStyle"
            size="small"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
            @cell-click="onCellClick"
            v-if="rowData.length > 0"
          >
            <el-table-column
              label="Position"
              property="Position"
            />
            <el-table-column
              label="Name"
              property="FullName"
              label-class-name="text-danger"
              class-name="d-none d-md-table-cell text-primary pointer"
            />
            <el-table-column
              class-name="d-none d-md-table-cell text-primary pointer"
              label="Email"
              label-class-name="text-danger"
            >
              <template slot-scope="props">
                <a :href="'mailto:' + props.row.EmailAddress">{{ props.row.EmailAddress }}</a>
              </template>
            </el-table-column>
            <el-table-column
              label="Phone"
              property="PhoneNumber"
              width="100px"
            />
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="Critter"
              property="PersonalCritter"
              width="100px"
            />
            <el-table-column
              label="First Time?"
              class-name="d-none d-md-table-cell text-center"
              width="100px"
            >
              <template slot-scope="props">
                <p-switch
                  v-if="props.row.value !== 0 && props.row.FullName"
                  v-model="props.row.FirstTimeStaff"
                  type="primary"
                  on-text="YES"
                  off-text="NO"
                  @change="onFirstTimeChanged(props.row)"
                />
              </template>
            </el-table-column>
            <el-table-column
              class-name="d-none d-md-table-cell action-buttons td-actions"
              align="center"
              width="85"
              label="Admin"
            >
              <template slot-scope="props">
                <p-switch
                  v-if="props.row.value !== 0 && props.row.IsUser && props.row.FullName"
                  v-model="props.row.IsAdmin"
                  type="primary"
                  on-text="YES"
                  off-text="NO"
                  @change="onIsAdminChanged(props.row)"
                />
                <span
                  v-else-if="props.row.value !== 0 && !props.row.IsUser && props.row.FullName"
                  class="h6"
                >Not User</span>
              </template>
            </el-table-column>
            <el-table-column
              class-name="d-none d-md-table-cell action-buttons td-actions"
              width="120"
              label="edit"
            >
              <template slot-scope="props">
                <p-button
                  v-if="props.row.Position !== 'Unassigned'"
                  type="info"
                  size="sm"
                  class="mt-1 mb-1"
                  title="Assign Staff Member"
                  icon
                  @click="showEditDialog(props.row)"
                >
                  <i class="ti-icon ti-exchange-vertical" />
                </p-button>
                <p-button
                  v-if="
                    !props.row.IsRequired && props.row.Position !== 'Unassigned'
                  "
                  type="danger"
                  size="sm"
                  class="mt-1 mb-1"
                  title="Delete"
                  icon
                  @click="deleteConfirm(props.row)"
                >
                  <i class="fa fa-times" />
                </p-button>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-else
            class="text-center"
          >
            <p class="card-category">
              There are no positions set up for this course.
            </p>
          </div>
          <p-button
            variant="success"
            @click="showAddPositionDialog"
          >
            Add Position
          </p-button>
        </card>
      </tab-pane>
      <tab-pane
        id="member"
        key="member"
      >
        <span slot="title">
          <div class="row align-items-center">
            <div class="content-heading">Staff Members</div>
          </div>
        </span>
        <edit-scouter
          scouter-type="staff"
          @scouter-added="scouterAdded"
        />
      </tab-pane>
    </tabs>
    <modal
      id="add-position"
      :show.sync="showAddPosition"
      title="Add Position"
      centered
      button-size="sm"
    >
      <template slot="header">
        <h4>Add Position</h4>
      </template>
      <fg-input>
        <label>What Position would you like to add?</label>
        <el-select
          class="select-default2"
          size="large"
          name="newPosition"
          placeholder=""
          v-model="newPosition"
        >
          <el-option
            v-for="option in positionsList"
            class="select-default2"
            :value="option.key"
            :label="option.name"
            :key="option.key"
          />
        </el-select>
      </fg-input>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showAddPosition = false"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          class="mr-2"
          @click="addPosition"
        >
          Save
        </p-button>
      </template>
    </modal>
    <modal
      id="add-position"
      :show.sync="showEditAssignment"
      centered
      button-size="sm"
    >
      <template slot="header">
        <h4>Assign Staff Member to Position</h4>
      </template>
      <fg-input>
        <label>What Staff Member would you like to assign to <strong>{{ editAssignmentInfo.positionName }}</strong>?</label>
        <el-select
          class="select-default2"
          clearable
          size="large"
          name="scouterAssign"
          placeholder=""
          v-model="editAssignmentInfo.courseScouterId"
        >
          <el-option
            v-for="(name, num) in staff"
            class="select-default2"
            :value="num"
            :label="name"
            :key="name"
          />
        </el-select>
      </fg-input>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showEditAssignment = false"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          class="mr-2"
          @click="editAssignedScouter"
        >
          Save
        </p-button>
      </template>
    </modal>
  </div>
</template>

<script>
import staffMemberPositionApi from '@/services/api/staff-member-position'
import statesList from '@/services/static/states.js'
import scouterApi from '@/services/api/scouter'
import positionsList from '@/services/static/positions'
import oops from '@/components/_main/oops.vue'
import Modal from '@/plugins/paper-components/modal.vue'
import editScouter from '@/components/scouters/scouter-edit.vue'
import Tabs from '@/plugins/paper-components/tabs/tabs.vue'
import TabPane from '@/plugins/paper-components/tabs/tab.vue'
import PSwitch from '@/plugins/paper-components/p-switch.vue'

export default {
  name: 'StaffEdit',
  components: {
    oops,
    Modal,
    editScouter,
    Tabs,
    TabPane,
    PSwitch
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      },
      rowData: null,
      loading: true,
      errormessage: null,
      showAddPosition: false,
      staff: null,
      staffNameList: null,
      showEditAssignment: false,
      editAssignmentInfo: {
        courseStaffPositionId: null,
        courseScouterId: null,
        positionName: null
      },
      positionsList: null,
      states: null,
      newPosition: null,
      staffMemberToRemove: null,
      inviteInfo: {
        invited: ''
      },
      tempHolding: null
    }
  },
  created () {
    this.states = statesList.GetStatesKeys()
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      staffMemberPositionApi
        .listStaffPositions(this.$root.courseKey)
        .then(x => {
          this.rowData = x
          this.getStaffList()
          this.positionsList = positionsList.getOptionalPositions()
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    onCellClick: function (row, column, cell, event) {
      this.tempHolder = { c: cell, r: row, co: column, e: event }
      if (column.label === 'Name') {
        const path = '/staff/participant?s=' + row.ScouterKey + '&r=staff-edit'
        this.$router.push(path)
      }
    },
    firstTimeText: function (firstTime) {
      return firstTime ? 'Yes' : 'No'
    },
    leadershipStyle: function (props) {
      if (props.row.IsLeader) {
        return 'leaderRow'
      } else {
        return ''
      }
    },
    getStaffList: function () {
      scouterApi
        .getStaffCourseScouterLookups(this.$root.courseKey)
        .then(y => {
          this.staff = y
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    showAddPositionDialog: function () {
      this.showAddPosition = true
    },
    addPosition: function () {
      staffMemberPositionApi
        .addStaffMemberPosition(this.$root.courseKey, this.newPosition)
        .then(y => {
          this.rowData = y
          this.showAddPosition = false
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error adding this position.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteConfirm: function (data) {
      const msg = 'Are you sure you want to delete ' + data.Position + '?'
      this.$confirm(msg, 'Are you sure?', {
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.deletePosition(data)
      })
    },
    deletePosition: function (data) {
      staffMemberPositionApi
        .removeCourseStaffPosition(
          this.$root.courseKey,
          data.CourseStaffPositionId
        )
        .then(x => {
          this.rowData = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting this position.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    removeStaffMember (bvModalEvt) {
      scouterApi
        .removeMemberFromStaff(this.$root.courseKey, this.staffMemberToRemove)
        .then(x => {
          this.rowData = x
          this.staffMemberToRemove = null
          this.getStaffList()
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    scouterAdded () {
      this.init()
    },
    onFirstTimeChanged: function (row) {
      this.tempHolding = row
      staffMemberPositionApi
        .updateStaffMemberFirstTimeStatus(
          this.$root.courseKey,
          row.CourseScouterId,
          row.FirstTimeStaff
        )
        .then(x => {
          this.rowData = x
          this.$notify({
            message: 'The update is complete.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating this scouter.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    onIsAdminChanged: function (row) {
      staffMemberPositionApi
        .updateStaffMemberAdminStatus(
          this.$root.courseKey,
          row.CourseScouterId,
          row.IsAdmin
        )
        .then(x => {
          this.rowData = x
          this.$notify({
            message: 'The update is complete.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating this scouter.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    showEditDialog: function (row) {
      this.editAssignmentInfo.courseStaffPositionId = row.CourseStaffPositionId
      this.editAssignmentInfo.courseScouterId = row.CourseScouterId !== null ? String(row.CourseScouterId) : null
      this.editAssignmentInfo.positionName = row.Position
      this.showEditAssignment = true
    },
    editAssignedScouter: function () {
      this.updateAssignedScouterToPosition(
        this.editAssignmentInfo.courseStaffPositionId,
        this.editAssignmentInfo.courseScouterId
      )
      this.showEditAssignment = false
    },
    updateAssignedScouterToPosition (courseStaffPositionId, courseScouterId) {
      staffMemberPositionApi
        .assignStaffMemberToPosition(
          this.$root.courseKey,
          courseStaffPositionId,
          courseScouterId
        )
        .then(x => {
          this.rowData = x
          this.showEditAssignment = false
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating this scouter.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.leaderRow {
  font-weight: bolder;
  background-color: #b7e4ff;
}
</style>
